import { includes, values } from 'lodash';

import { sortOrderKeys } from '../../configuration/sorting';

export function getDefaultSortOrder(isDestinationPage, configSortOrder) {
  const isValidSortOrder = includes(
    values(sortOrderKeys),
    configSortOrder
  );
  if (isValidSortOrder) return configSortOrder;

  return isDestinationPage ? sortOrderKeys.newest : sortOrderKeys.popAsc;
}
